import styled from 'styled-components'
import { Tabs, TabList as TL, Tab as SingleTab, TabPanel } from 'react-tabs'
import { rem } from '../../styles/Mixins'
import { media } from 'styled-bootstrap-grid'

const TabList = styled(TL)`
  display: flex;
  justify-content: center;
  padding-bottom: ${rem(32)};
  margin: 0 auto;
  padding-left: 0;
  /* max-width: 375px; */

  /* .home & {
    max-width: 425px;
  } */

  ${media.xl`
    padding-bottom: ${rem(65, 'xxxl')};
    /* max-width: 550px; */

    .home & {
      /* max-width: 675px; */
    }
  `}
`

const Tab = styled(SingleTab)`
  margin: 0;
  margin-right: ${rem(20)};
  font-family: 'foco_cc_bold', sans-serif;
  font-size: ${rem(12)};
  text-decoration: none;
  color: ${(props) => props.theme.colors.grey};
  text-transform: uppercase;
  padding: ${rem(8)} ${rem(10)};
  display: block;
  border-radius: 0 10px;
  cursor: pointer;
  outline: none;
  position: relative;
  z-index: 1;
  transition: all 0.2s ease-in-out;

  .home & {
    margin-right: 10px;

    ${media.xl`
      margin-right: ${rem(28, 'xxxl')};
    `}

    @media screen and (max-width: 425px) {
      margin-right: 5px;
      font-size: 0.65rem;
    }
  }

  :last-child {
    margin-right: 0;
  }

  span {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    color: ${(props) => props.theme.colors.primary_light};
    margin-top: 2px;
    font-size: ${rem(15)};
    opacity: 0;

    ${media.lg`
      margin-top: 6px;
    `}

    svg {
      @media screen and (min-width: 0\0) {
        max-width: 11px;
        max-height: 17px;
      }
    }
  }

  :hover {
    color: ${(props) => props.theme.colors.primary_light};
  }

  &.is-selected {
    background-color: ${(props) => props.theme.colors.primary_light};
    color: ${(props) => props.theme.colors.white};

    span {
      opacity: 1;
    }
  }

  ${media.xl`
    font-size: ${rem(20, 'xxxl')};
    padding: ${rem(8, 'xxxl')} ${rem(25, 'xxxl')};
    margin-right: ${rem(28, 'xxxl')};
  `}
`

export { TabList, Tabs, TabPanel, Tab }
